import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  FDPrimaryActionButton,
  FDStack,
  FDContentContainer,
  FDBox,
} from '@facet-wealth/design';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import PageHeader from 'Components/ComponentLibrary/Molecules/PageHeader';
import { HouseholdProfileBreadcrumbs } from 'Components/ComponentLibrary/Organisms/HouseholdProfileBreadcrumbs';
import { PaymentDetailRow } from './PaymentDetailRow';


const PaymentInfoProfileSubpage = ({
  resource,
}) => {
  useBoneBackgroundColor();
  const isMobile = useMobileLayout();
  const paymentDetails = resource.attr('paymentMethods').resources().list();
  const { loadPageContentLink } = usePageContentContext();

  return (
    <FDContentContainer maxWidth={'xl'}>
      <PageHeader
        breadcrumbs={<HouseholdProfileBreadcrumbs resource={resource} onClickBreadcrumb={(link) => loadPageContentLink(link)} />}
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <FDStack direction={'column'} alignItems={'flex-start'} spacing={isMobile ? 3 : 6}>
        <FDStack spacing={2} direction={isMobile ? 'column' : 'row'} alignItems={'stretch'} width={'100%'}>
          {paymentDetails.map(paymentDetail => (
            <PaymentDetailRow key={paymentDetail.id()} resource={paymentDetail} />
          ))}
        </FDStack>
        <FDBox>
          {resource.withRelationship(fr.relationships.creditCardPaymentMethodPage.name, (rel) => {
            return (
              <FDPrimaryActionButton
                onClick={() => loadPageContentLink(rel.link('related'))}
                test={'profile-page-subpage-payment-info-add-credit-card'}
                label={rel.meta('prompt')}
              />
            );
          }, () => null)}
        </FDBox>
      </FDStack>
    </FDContentContainer>
  );
};

PaymentInfoProfileSubpage.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default PaymentInfoProfileSubpage;
